// Module
var code = "<wt-export-configuration class=\"flex-directive\" begin-date-time=\"vm.beginDate\" end-date-time=\"vm.endDate\" form-controller=\"vm.formController\" on-cancel=\"vm.onCancel()\" on-save=\"vm.onSave()\" queries=\"vm.queries\" selected=\"vm.selectedItem\"> </wt-export-configuration>";
// Exports
module.exports = code;